import React from 'react';
import styled from '@emotion/styled';

interface Props {
  label: string;
  color: string;
}

const Component: React.FCX<Props> = ({ className, label }) => <h2 className={className}>{label}</h2>;

const StyledComponent = styled(Component)`
  margin: 0 auto 2em;
  text-align: center;
  color: ${({ color }) => color};
  font-weight: 600;
`;

export default StyledComponent;
